import { call, put, takeLatest } from 'redux-saga/effects';

import {
  getLocationsError,
  getLocationsRequest,
  getLocationsSuccess,
  getResourcesError,
  getResourcesRequest,
  getResourcesSuccess,
  putResourcesError,
  putResourcesRequest,
  putResourcesSuccess,
} from './actions';
import { GET_LOCATIONS_REQUEST, GET_RESOURCES_REQUEST, PUT_RESOURCES_REQUEST } from './constants';
import { ResourcesService } from './service';

function* getLocationsRequestSaga(action: ReturnType<typeof getLocationsRequest>) {
  try {
    // @ts-ignore
    const response = yield call(ResourcesService.getLocations, action.payload);

    yield put(getLocationsSuccess(response));
  } catch (error: any) {
    yield put(getLocationsError(error));
  }
}

function* getResourcesRequestSaga(action: ReturnType<typeof getResourcesRequest>) {
  try {
    // @ts-ignore
    const response = yield call(ResourcesService.getResources, action.payload);

    yield put(getResourcesSuccess(response));
  } catch (error: any) {
    yield put(getResourcesError(error));
  }
}

function* putResourcesRequestSaga(action: ReturnType<typeof putResourcesRequest>) {
  try {
    // @ts-ignore
    yield call(ResourcesService.putResources, action.payload);

    yield put(putResourcesSuccess());
  } catch (error: any) {
    yield put(putResourcesError(error));
  }
}

export function* ResourcesSagaWatcher() {
  yield takeLatest(GET_LOCATIONS_REQUEST, getLocationsRequestSaga);
  yield takeLatest(GET_RESOURCES_REQUEST, getResourcesRequestSaga);
  yield takeLatest(PUT_RESOURCES_REQUEST, putResourcesRequestSaga);
}
